module.exports = __webpack_public_path__ + "asana-logo.png";


//////////////////
// WEBPACK FOOTER
// ./images/integrations/asana-logo.png
// module id = 1250
// module chunks = 74